export const speedWord = (tempo) => {
  if (tempo === null || tempo === undefined || tempo === '') return null;
  const bpm = Number(tempo);
  if (!Number.isFinite(bpm)) return null;
  if (bpm <= 85) return 'Laid back';
  if (bpm <= 110) return "Groovin'";
  if (bpm <= 145) return "Movin'";
  return 'Fast';
};

export const speedFilters = [
  { id: 'all', label: 'All speeds', matches: () => true },
  { id: 'laid-back', label: 'Laid back (up to 85)', matches: (bpm) => Number.isFinite(Number(bpm)) && Number(bpm) <= 85 },
  { id: 'groovin', label: "Groovin' (86-110)", matches: (bpm) => Number(bpm) >= 86 && Number(bpm) <= 110 },
  { id: 'movin', label: "Movin' (111-145)", matches: (bpm) => Number(bpm) >= 111 && Number(bpm) <= 145 },
  { id: 'fast', label: 'Fast (146+)', matches: (bpm) => Number(bpm) >= 146 },
];
